import {Injectable} from '@angular/core';
import {UtilityService} from '@irb/irb-common/services/utility.service';
import {IPortfolioCustomLabel} from '@irb/irb-editors/irb-editors.model';
import {PortfolioService} from '@irb/irb-clients/portfolios/portfolio.service';
import {IFilterModel} from '@irb/app.model';
import {AppService} from '@irb/app.service';
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {IrbSettingsEvents} from '@irb-common/events';
import {HoverPanelService} from '@irb-common/components/hover-panel/hover-panel.service';

@Injectable({providedIn: 'root'})
export class PortfolioLabelsService {
    portfolioLabels: Array<IPortfolioCustomLabel>;

    constructor(
        private pfs: PortfolioService, 
        private util: UtilityService, 
        private as: AppService,
        private hps: HoverPanelService,
    ) {}

    getPortfolioLabels(parent: any) {
        this.pfs.getLabels().subscribe((data: any) => {
          this.portfolioLabels = data;
          this.portfolioLabels = this.util.sortByKey(this.portfolioLabels, 'name', 'asc');
          
          parent.params.api.getColumnFilterInstance('labels').then((f: any) => {
            f.data = this.getDropdownOptionsForLabels(this.portfolioLabels);

            if(f.params) {
              f.params.values = [{name: '(none)', value: 'uncategorized'}].concat(f.data);
              f.data = [{name: '(none)', value: 'uncategorized'}].concat(f.data);
            }

            let filterModel: IFilterModel = this.as.getFieldInfo(parent.applyFilterOnLanding, 'valueLabel');
    
            if (filterModel && filterModel.value && filterModel.isUpdatRequired) {
              filterModel.isUpdatRequired = false;
              parent.applyFilterOnLanding.isUpdatRequired = false;
              
              f.values = f.getIDropdownItems([filterModel.value]);
              parent.params.api.setFilterModel({'labels': { 'values': [filterModel.value]}});
              parent.params.api.onFilterChanged();
    
              if (!parent.hasServerSideDatasource) {
                parent.params.api.setGridOption('serverSideDatasource', parent.setDatasource());
              }
            }  
          });      
        });
    }

    getDropdownOptionsForLabels(labels: Array<IPortfolioCustomLabel>) {
        let d: IDropdownItem[] = [];
        
        labels?.forEach((x: IPortfolioCustomLabel) => {
          d.push({name: x.name, value: x.id} as IDropdownItem);
        });

        return d;
    }

    openGlobalSettings() {
        this.as.fireEvent(IrbSettingsEvents.SHOW, {
          defaultTabIndex: 2, 
          onFirstLoad: () => { 
            setTimeout(() => { 
              this.as.fireEvent(IrbSettingsEvents.EXPAND_CUSTOM_LABELS);
              document.getElementById("CUSTOM_CATEGORIES")?.scrollIntoView(); 
            });
          }
        });
    
        this.hps.remove();
      }
}
